"use strict";

var _attachments = require("libs/utils/attachments");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
module.exports =
/*#__PURE__*/
/* @ngInject */
function () {
  AssetEssencePreviewCtr.$inject = ["$scope", "eventService", "model"];
  function AssetEssencePreviewCtr($scope, eventService, model) {
    _classCallCheck(this, AssetEssencePreviewCtr);
    $scope.$ctrl = this;
    this.event = eventService.getCurrentEvent();
    this.model = model;
  }
  return _createClass(AssetEssencePreviewCtr, [{
    key: "getIdealAssetDownloadFilename",
    value: function getIdealAssetDownloadFilename(fpAssetPath) {
      return fpAssetPath.substring(fpAssetPath.indexOf('.') + 1, fpAssetPath.indexOf('/')) + fpAssetPath.substring(fpAssetPath.lastIndexOf('.'));
    }
  }, {
    key: "shouldShowImageAssetPreview",
    value: function shouldShowImageAssetPreview(model) {
      var contentType = this.getAssetAttachmentContentType(model);
      var t = contentType.substring(0, contentType.indexOf('/'));
      return t === 'image';
    }
  }, {
    key: "getAssetAttachmentContentType",
    value: function getAssetAttachmentContentType(model) {
      var attachmentsNames = (0, _attachments.getAttachmentNames)(model);
      return ((0, _attachments.getAttachmentMetadata)(model, attachmentsNames[0]) || {}).content_type;
    }
  }]);
}();